document.addEventListener('DOMContentLoaded', function() {
  // Select the toggle button, filters container, and product grid container
  const toggleButton = document.getElementById('toggle-filters');
  const filtersContainer = document.getElementById('main-collection-filters');
  
  // Set initial caret state
  const caretIcon = toggleButton.querySelector('.icon-caret');
  if (caretIcon) {
    caretIcon.classList.add('nf-rotate-90');
  }
  
  // Set initial state (visible by default based on the provided HTML)
  let isVisible = true;
  
  // Store original values
  const originalWidth = '30rem';
  
  // Create a wrapper around the filters container if it doesn't exist
  const wrapperExists = filtersContainer.parentElement.classList.contains('filters-drawer-wrapper');
  let drawerWrapper;
  
  if (!wrapperExists) {
    // Create drawer wrapper
    drawerWrapper = document.createElement('div');
    drawerWrapper.className = 'filters-drawer-wrapper';
    
    // Insert wrapper
    filtersContainer.parentNode.insertBefore(drawerWrapper, filtersContainer);
    drawerWrapper.appendChild(filtersContainer);
  } else {
    drawerWrapper = filtersContainer.parentElement;
  }
  
  // Apply initial styles via classes instead of inline styles
  drawerWrapper.classList.add('filters-drawer-visible');
  
  // Function to toggle visibility with drawer-like animation
  function toggleFilters() {
    if (isVisible) {
      // Hide the filters with drawer effect
      drawerWrapper.classList.remove('filters-drawer-visible');
      drawerWrapper.classList.add('filters-drawer-hidden');
      
      // Update the button text using the attribute
      const spanElement = toggleButton.querySelector('span');
      if (spanElement && spanElement.hasAttribute('show-filter-label')) {
        spanElement.textContent = spanElement.getAttribute('show-filter-label');
      }
      
      // Update button classes and rotate caret
      toggleButton.classList.remove('filters-visible');
      toggleButton.classList.add('filters-hidden');
      
      // Find and rotate the caret icon
      const caretIcon = toggleButton.querySelector('.icon-caret');
      if (caretIcon) {
        caretIcon.classList.remove('nf-rotate-90');
        caretIcon.classList.add('nf--rotate-90');
      }
      
      // Update accessibility attributes
      toggleButton.setAttribute('aria-expanded', 'false');
      
      // Update state
      isVisible = false;
    } else {
      // Show the filters with drawer effect
      drawerWrapper.classList.remove('filters-drawer-hidden');
      drawerWrapper.classList.add('filters-drawer-visible');
      
      // Update the button text using the attribute
      const spanElement = toggleButton.querySelector('span');
      if (spanElement && spanElement.hasAttribute('hide-filter-label')) {
        spanElement.textContent = spanElement.getAttribute('hide-filter-label');
      }
      
      // Update button classes and rotate caret
      toggleButton.classList.remove('filters-hidden');
      toggleButton.classList.add('filters-visible');
      
      // Find and rotate the caret icon
      const caretIcon = toggleButton.querySelector('.icon-caret');
      if (caretIcon) {
        caretIcon.classList.remove('nf--rotate-90');
        caretIcon.classList.add('nf-rotate-90');
      }
      
      // Update accessibility attributes
      toggleButton.setAttribute('aria-expanded', 'true');
      
      // Update state
      isVisible = true;
    }
  }
  
  // Add click event listener to the toggle button
  toggleButton.addEventListener('click', function(e) {
    e.preventDefault();
    toggleFilters();
  });
  
  // Efficiently handle window resizing with debouncing
  let resizeTimeout;
  function handleResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      // Resize logic here if needed
    }, 250); // 250ms debounce
  }
  
  window.addEventListener('resize', handleResize);
  
  // Handle case where content inside filters changes
  const observer = new MutationObserver(function() {
    // Only update if needed
  });
  
  observer.observe(filtersContainer, { 
    childList: true, 
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });
  
  // Add CSS for smooth animations
  const style = document.createElement('style');
  style.textContent = `
    .filters-drawer-visible {
      width: ${originalWidth};
    }
  `;
  document.head.appendChild(style);
});